// extracted by mini-css-extract-plugin
export default {"nopermission":"NotRegisteredAd_nopermission__aVABv"};